const schemaArray = [
  {
    actionType: "PROMPT",
    schema: {
      type: "object",
      properties: {
        prompt: {
          type: "string",
          title: "Prompt Text",
          description: "The prompt text to be used",
          minLength: 1,
          maxLength: 2000,
        },
      },
      required: ["prompt"],
    },
  },
  {
    actionType: "LAUNCH_PROCESS",
    schema: {
      type: "object",
      properties: {
        process_id: {
          type: "string",
          title: "Process ID",
          format: "uuid",
          description: "The UUID of the process to be launched",
        },
        per_each: {
          type: "string",
          title: "Per Each",
          enum: ["NONE", "JSON_ARRAY_ITEM"],
          default: "NONE",
          description:
            "Whether to launch the process for each item in a JSON array",
        },
      },
      required: ["process_id"],
    },
  },
  {
    actionType: "LAMBDA",
    schema: {
      type: "object",
      properties: {
        function_url: {
          type: "string",
          title: "Function URL",
          description: "The URL of the Lambda function to invoke",
          format: "uri",
        },
      },
      required: ["function_url"],
    },
  },
];

export function getSchemaForActionType(actionType: string) {
  const schemaItem = schemaArray.find((item) => item.actionType === actionType);
  return schemaItem ? schemaItem.schema : null;
}

export {};
